import { render, staticRenderFns } from "./shortClockDesign.vue?vue&type=template&id=6418737a&scoped=true"
import script from "./shortClockDesign.vue?vue&type=script&lang=js"
export * from "./shortClockDesign.vue?vue&type=script&lang=js"
import style0 from "./shortClockDesign.vue?vue&type=style&index=0&id=6418737a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6418737a",
  null
  
)

export default component.exports